import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";

const stripSlash = str => {
	return str.substring(str.length - 1) === "/"
		? str.substring(0, str.length - 1)
		: str;
};

class MetaTags extends React.Component {
	render() {
		const { pathname, siteMetadata } = this.props,
			pathnameWithoutSlash = stripSlash(pathname),
			pathparts = pathnameWithoutSlash.split("/"),
			currentPage = pathnameWithoutSlash === "" ? "home" : pathparts[1],
			allMetaTags = siteMetadata.metaTags,
			metaTags = allMetaTags.filter(({ page }) => {
				return page === currentPage;
			});

		return (
			<div>
				{metaTags.length === 1 &&
					<Helmet
						title={
							metaTags[0].page === "home"
								? metaTags[0].title
								: `${metaTags[0].title} | ${siteMetadata.title}`
						}
						meta={[
							{
								content: siteMetadata.googleSiteVerification,
								name: "google-site-verification"
							},
							{
								content: metaTags[0].description,
								name: "description"
							},
							{
								content: metaTags[0].keywords,
								name: "keywords"
							}
						]}
					/>
				}
			</div>
		);
	}
}

MetaTags.propTypes = {
	pathname: PropTypes.string.isRequired,
	siteMetadata: PropTypes.shape({
		googleSiteVerification: PropTypes.string.isRequired,
		metaTags: PropTypes.array.isRequired,
		title: PropTypes.string.isRequired
	})
};
export default MetaTags;



// WEBPACK FOOTER //
// ./src/components/Header/metaTags.js